import type { StartShopifyCheckoutParams } from '@shared/api/billing.service'
import { useMutation, useQuery, UseQueryOptions } from 'react-query'
import { ApiService } from 'src/services/api.service'

export const GET_SHOPIFY_MANAGE_URL_CACHE_KEY = 'get-shopify-manage-url'
export const GET_SHOPIFY_CANCEL_URL_CACHE_KEY = 'get-shopify-cancel-url'

/**
 * Lazily fetches the Shopify Admin URL the merchant should visit to manage
 * billing. Only enabled when the caller knows the user is Shopify-billed.
 */
export function useShopifyManageUrl(options?: UseQueryOptions<{ shopify_admin_url: string }>) {
  return useQuery(GET_SHOPIFY_MANAGE_URL_CACHE_KEY, () => ApiService.Billing.getShopifyManageUrl(), {
    staleTime: 5 * 60 * 1000,
    ...options,
  })
}

/**
 * Deep link into the embedded Shopify app (`?sr_intent=cancel`) so the merchant
 * can complete `appSubscriptionCancel` in admin context.
 */
export function useShopifyCancelUrl(options?: UseQueryOptions<{ shopify_admin_url: string }>) {
  return useQuery(GET_SHOPIFY_CANCEL_URL_CACHE_KEY, () => ApiService.Billing.getShopifyCancelUrl(), {
    staleTime: 5 * 60 * 1000,
    ...options,
  })
}

/**
 * Mutation that resolves the Shopify Admin URL to start a subscription
 * approval flow. The caller is expected to redirect to the returned URL
 * (Shopify Billing requires admin context for `appSubscriptionCreate`).
 */
export function useStartShopifyCheckout() {
  return useMutation((params: StartShopifyCheckoutParams) => ApiService.Billing.startShopifyCheckout(params))
}
